import { all, put, takeEvery } from 'redux-saga/effects';

import { getLogger } from '../../logger/index';

const logger = getLogger('whitelabel');

function* initPlugins({ payload }) {
  if (payload && payload.data && payload.data.plugins) {
    const activePlugins = payload.data.plugins.filter(plugin => plugin.is_active);
    const actions = activePlugins.map(plugin => put({ type: 'PLUGIN_INIT_' + plugin.id, payload: plugin }));
    logger.debug('Init plugins', actions);
    yield all(actions);
  }
}

function* watchWhitelabelSettings() {
  logger.debug('Watching whitelabelsettings actions');
  yield takeEvery('WHITE_LABEL_SETTINGS_FULFILLED', initPlugins);
}
export default [watchWhitelabelSettings];
